export class VCardGenerator {
    static getUrlOrDowndload(card: Record<string, any>, name: string, force = false): string | void {

        const url = this.genarateUrl(card);

        if (force) {
            let a = document.createElement('a');
            a.download = name + ".vcf";
            a.href = url;
            a.click();
        }
        else {
            return url;
        }
    }

    private static genarateUrl(card: Record<string, any>) {
        if (Blob) {
            const blob = new Blob([this.dump(card)], { "type": "text/vcard" })
            return URL.createObjectURL(blob)
        } else {
            return "data:text/vcard;base64," + this.btoa(this.dump(card))
        }
    }

    private static btoa(str: string) {
        str = unescape(encodeURIComponent(str))

        const b64c = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

        let i, res = "", length = str.length;
        for (i = 0; i < length - 2; i += 3) {
            res += b64c[str.charCodeAt(i) >>> 2];
            res += b64c[((str.charCodeAt(i) & 3) << 4) | (str.charCodeAt(i + 1) >>> 4)];
            res += b64c[((str.charCodeAt(i + 1) & 15) << 2) | (str.charCodeAt(i + 2) >>> 6)];
            res += b64c[str.charCodeAt(i + 2) & 63];
        }

        if (length % 3 === 2) {
            res += b64c[str.charCodeAt(i) >>> 2];
            res += b64c[((str.charCodeAt(i) & 3) << 4) | (str.charCodeAt(i + 1) >>> 4)];
            res += b64c[((str.charCodeAt(i + 1) & 15) << 2)];
            res += "=";
        } else if (length % 3 === 1) {
            res += b64c[str.charCodeAt(i) >>> 2];
            res += b64c[((str.charCodeAt(i) & 3) << 4)];
            res += "==";
        }

        return res;
    }

    private static dump(card: Record<string, any>) {
        let str = "BEGIN:VCARD\n"

        for (let key in card) {
            let entry = card[key]

            if (typeof entry === "function")
                {continue}

            if (Object.prototype.toString.call(entry) === "[object Array]") {
                for (let i = 0, l = entry.length; i < l; i++) {
                    let e = entry[i]
                    str += key.toUpperCase() + (e.type ? ";TYPE=" + e.type.toUpperCase() + ":" : ":") + e.value + "\n"
                }
            } else if (typeof entry === "object") {
                str += key.toUpperCase() + (entry.type ? ";TYPE=" + entry.type.toUpperCase() + ":" : ":") + entry.value + "\n"
            } else {
                str += key.toUpperCase() + ":" + entry + "\n"
            }
        }

        str += "END:VCARD"
        return str
    }
}